import { EmploymentOccupation } from "../../lead-api";
import { type OccupationMenuItem } from "../Employment.types";

export const employmentMenuItemsMY: OccupationMenuItem[] = [
  {
    label: "inputs.employment.private_sector",
    value: EmploymentOccupation.PrivateSector,
  },
  {
    label: "inputs.employment.public_sector",
    value: EmploymentOccupation.PublicSector,
  },
  {
    label: "inputs.employment.self_employed",
    value: EmploymentOccupation.SelfEmployed,
  },
  {
    label: "inputs.employment.business_owner",
    value: EmploymentOccupation.BusinessOwner,
  },
  {
    label: "inputs.employment.freelancer",
    value: EmploymentOccupation.Freelancer,
  },
  {
    label: "inputs.employment.temporary_employed",
    value: EmploymentOccupation.TemporaryEmployed,
  },
  {
    label: "inputs.employment.not_employed",
    value: EmploymentOccupation.Unemployed,
  },
  {
    label: "inputs.employment.retired",
    value: EmploymentOccupation.Retired,
  },
  {
    label: "inputs.employment.student",
    value: EmploymentOccupation.Student,
  },
];
